import { call, put } from 'redux-saga/effects';

import { SetDisplayTabsAction } from '~content/services/SetDisplayTabsAction';
import { requestFailed } from '~src/app/actions/RequestFailedAction';
import { requestSpaceContents } from '~src/app/actions/spaces/RequestSpaceContentsActions';
import { Messages } from '~src/codegen/Localize';
import { Set } from '~src/ts/models/Set';
import { SetTabsWorkbookAction } from '~src/workbook/actions/SetTabsWorkbookAction';
import { IWorkbookInfo } from '~src/workbook/models/IWorkbookInfo';

import { reloadSpaceIfUpdatingCurrentSpace } from '../../app/sagas/spaces/content/RefreshContentSagas';
import { getWorkbookInfos } from '../../app/sagas/spaces/SpacesSagaHelpers';

export function* setTabsWorkbookSaga(action: SetTabsWorkbookAction) {
    const localizedErrorMessage = Messages.unexpectedError();
    try {
      const workbookInfos = yield getWorkbookInfos(action.workbooks);
      // errors are handled by the dialog - nothing to be done on success
      yield call(openSetTabsWorkbookDialog, workbookInfos);

      const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, action.workbooks);
      if (!maybeReloaded) {
        yield put(requestSpaceContents());
      }

    } catch(e) {
      yield put(requestFailed(e, localizedErrorMessage));
    }
  }

function openSetTabsWorkbookDialog(workbooks: IWorkbookInfo[]): Promise<any> {
    const workbooksSet = Set.fromIdItemArray(workbooks);
    return SetDisplayTabsAction.confirmSetDisplayTabs(workbooksSet);
  }
